import { Pipe, PipeTransform } from '@angular/core';
import { StringUtilities } from '@shared/utility/string-utilities';

@Pipe({
    name: 'pluralize',
    standalone: false
})
export class PluralizePipe implements PipeTransform {

  transform(value: number, noun: string = null, suffix = 's'): string | null {
    let res: string = null;
    if (typeof value === 'number') {
      noun = suffix === 'ies' && value !== 1
        ? noun.slice(0, -1)
        : noun;

      res = value + ' ' + StringUtilities.pluralize(value, noun, suffix);
    }
    return res;
  }

}
